import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { AlertContext } from '../../contexts/AlertContext';
import { LoaderContext } from '../../contexts/LoaderContext';
import { convertirLetraMayus } from '../../helpers/convertirLetraMayus';
import { formatearFecha } from '../../helpers/fechaHoras';
import { SocketContext } from '../../contexts/SocketContext';
import { Contador } from '../../components/turns/Contador';
import { sumarTiempos } from '../../helpers/sumarTiempos';
import dayjs from 'dayjs';

const columns = [
    { id: 'turno', label: 'Turno', minWidth: 170, align: 'center' },
    { id: 'transacciones', label: 'Transacciones', minWidth: 100, align: 'center' },
    { id: 'creado', label: 'Fecha', minWidth: 170, align: 'center' },
    { id: 'espera', label: 'Espera', minWidth: 170, align: 'center' },
    { id: 'atencion', label: 'Atención total', minWidth: 170, align: 'center' },
    { id: 'cajero', label: 'Cajero', minWidth: 170, align: 'center' }
];

export const useHistoryTurns = (sede) => {
    
    //*ESTADOS
    const [total, setTotal] = useState(0);
    const [historyTurns, setHistoryTurns] = useState([]);
    //*CONTEXTOS
    const { setOpenLoader } = useContext(LoaderContext);
    const { alertRef } = useContext(AlertContext);
    const { socket } = useContext(SocketContext);

    useEffect(() => {
        let unsubscribed = true;
        unsubscribed && refrescarTurnos();

        return () => socket.off('backend:refrescar-turnos');
    }, []);

    useLayoutEffect(() => {
        let subscribed = true;
       
        subscribed && obtenerTurnos();
    
        return () => {
            subscribed = false;
            socket.off('frontend:obtener-turnos');
        }
    }, [sede]);

    const obtenerTurnos = () => {
        setOpenLoader(true);
        const payload ={
            sede, 
            estado: 4,
            creado: { $gte:`${ dayjs().format('YYYY-MM-DD') }T00:00:00.000Z`, $lte:`${ dayjs().format('YYYY-MM-DD') }T23:59:59.999Z` }
        }

        socket.emit('frontend:obtener-turnos', payload, (response) => {
            const { ok, message, total, data } = response;

            if(!ok) {
                setOpenLoader(false);
                alertRef.current.handleOpen('error', message);
                return;
            }
           
            setHistoryTurns(data.map(turno => construirPayload(turno)));   
            setTotal(total);      
            setOpenLoader(false);
        });
    }

    const refrescarTurnos = () => socket.on('backend:refrescar-turnos', (response) => {
        const { ok, message, total, data } = response;

        if(!ok) {
            setOpenLoader(false);
            alertRef.current.handleOpen('error', message);
            return;
        }

        if(data?.sede?._id !== sede) return;

        if(data?.estado === 4) {
            setTotal(e => e + total);
            return agregarTurnoAlArreglo(data);
        }
    });

    const agregarTurnoAlArreglo = (turno) => {
        setHistoryTurns(prev => ([ ...prev, construirPayload(turno) ]));
    }

    const construirPayload = (turno) => ({
        ...turno,
        uid: turno?.uid,
        turno: turno?.turno?.toUpperCase(),
        transacciones: turno?.transacciones?.map(t => t?.tramite?.abreviacion || 'n/a')?.join(' - ').toUpperCase(),
        creado: (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span>{ formatearFecha(turno?.creado) }</span>
                <span style={{ fontSize: 12, fontWeight: 600 }}>{ dayjs(turno?.creado).format('hh:mm:ss A') }</span>
            </div>
        ),
        espera: <Contador fecha={ turno?.tiempo_espera } />,
        atencion: sumarTiempos(turno?.transacciones),
        cajero: convertirLetraMayus(turno?.cajero?.nombre, true)
    })

    return {
        columns,
        total,
        historyTurns,
    }
}